import { render, staticRenderFns } from "./DeviceTagsSelect.vue?vue&type=template&id=20cf4f02"
import script from "./DeviceTagsSelect.vue?vue&type=script&lang=js"
export * from "./DeviceTagsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports